/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.ECommerce {
     
    @Serenity.Decorators.registerClass()
    export class OrderManagementCheckListEditor extends _Ext.GridEditorBase<ECommerce.OrderManagementCheckListRow> {
        inlineEditAllowed: boolean;


        protected getColumnsKey() { return "ECommerce.OrderManagementCheckList"; }
        protected getDialogType() { return OrderManagementCheckListDialog; }
        protected getLocalTextPrefix() { return OrderManagementCheckListRow.localTextPrefix; }
        protected form: Retail.POSReturnItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }

      

        constructor(container: JQuery) {
            super(container); 
            this.slickGrid.setOptions({ forceFitColumns: true });
           
        }
 
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            //var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            //var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);

            //if (ECommReturnItemsEditor.baseitemcheck == 2) {
            //    columns = columns.filter(x => x.field != "SKU" && x.field != "Line_No" && x.field != "DiamondWeight" &&
            //        x.field != "StoneWeight" && x.field != "OtherWeight" && x.field != "UnitLabour" &&
            //        x.field != "NetWeight" && x.field != "WstWt" && x.field != "WstPer");
            //}
            //if (this.inlineEditAllowed) {
            //    Q.first(columns, x => x.field === fld.Pieces).format = int;
            //    Q.first(columns, x => x.field === fld.Weight).format = num;
            //}

            ////To Add Delete Button on Item Row
            //columns.unshift({
            //    field: 'Delete Row',
            //    name: '',
            //    format: ctx => '<a class="inline-action delete-row" title="delete">' +
            //        '<i class="fa fa-trash-o text-red"></i></a>',
            //    width: 24,
            //    minWidth: 24,
            //    maxWidth: 24
            //});

            return columns;
        }

        // #endregion

      
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var id = this.id(item);
            var target = $(e.target);

            if (target.hasClass('check-box no-float readonly') || target.hasClass('check-box no-float readonly checked'))
                target.removeClass('readonly')

            if (target.hasClass('check-box no-float')) {
                if (item.CheckListValue == true) {
                    item.CheckListValue = false;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                }
                else {
                    item.CheckListValue = true;
                    this.view.updateItem(id, item);
                    this.view.refresh();

                }
            }

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        this.view.deleteItem(id);
                        this.view.refresh();
                    });
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }



        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }
        public setData(items: any[]) {
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                item[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item);
            }
        }

        // #endregion
         
    }
}